import {
  ShaderStore,
  init_shaderStore
} from "./chunk-74QERPGX.mjs";
import {
  __esm
} from "./chunk-AU4RG7EN.mjs";

// node_modules/@babylonjs/core/Shaders/ShadersInclude/meshUboDeclaration.js
var name, shader;
var init_meshUboDeclaration = __esm({
  "node_modules/@babylonjs/core/Shaders/ShadersInclude/meshUboDeclaration.js"() {
    "use strict";
    init_shaderStore();
    name = "meshUboDeclaration";
    shader = `#ifdef WEBGL2
uniform mat4 world;uniform float visibility;
#else
layout(std140,column_major) uniform;uniform Mesh
{mat4 world;float visibility;};
#endif
#define WORLD_UBO
`;
    ShaderStore.IncludesShadersStore[name] = shader;
  }
});

export {
  init_meshUboDeclaration
};
